import React, { useState } from "react";
import type { ChatSummary } from "./types";
import { Button } from "../../../components/tailwind";

type ChatSelectMenuProps = {
  summaries: ChatSummary[];
  onChatSelect: (chatId: number) => void;
  onChatCreate: () => void;
  onChatDelete: (chatId: number) => void;
  activeChatId?: number;
};

export const ChatSelectMenu: React.FC<ChatSelectMenuProps> = ({
  summaries,
  onChatSelect,
  onChatCreate,
  onChatDelete,
  activeChatId,
}) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(true);

  const renderChatLink = (chatSummary: ChatSummary): React.JSX.Element => (
    <li
      key={chatSummary.id}
      onClick={(e) => {
        e.stopPropagation();
        onChatSelect(chatSummary.id);
      }}
      className={`txu-btn tw-block tw-relative tw-p-2 tw-my-4 ${
        activeChatId === chatSummary.id
          ? "tw-border-gray-300 hover:!tw-shadow-none hover:!tw-brightness-100"
          : ""
      }`}
    >
      <h3 className="tw-text-base">{chatSummary.name}</h3>
      <span className="tw-text-sm tw-text-gray-600">
        {chatSummary.timeSinceActive}
      </span>
      <Button
        onClick={(e) => {
          e.stopPropagation();
          onChatDelete(chatSummary.id);
        }}
        compact="very"
        className="tw-absolute tw-top-2 tw-right-2 !tw-px-1"
        borderless
        data-balloon="Delete Chat"
        data-balloon-pos="right"
        icon
      >
        <i className="material-icons tw-text-xl">delete</i>
      </Button>
    </li>
  );

  return (
    <nav>
      <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 -tw-mt-1 tw-mb-4 -tw-ml-1">
        <button
          className="tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-text-secondary"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          data-balloon="Toggle Sidebar"
          data-balloon-pos="up-left"
        >
          <i className="material-icons tw-text-2xl">auto_awesome_mosaic</i>
          {sidebarOpen && <span>Chat history</span>}
        </button>
        {!sidebarOpen && (
          <button
            className="tw-rounded-lg tw-text-secondary"
            onClick={onChatCreate}
            data-balloon="Start New Conversation"
            data-balloon-pos="down-left"
          >
            <i className="material-icons tw-text-2xl">add</i>
          </button>
        )}
      </div>
      {sidebarOpen && (
        <ul className="tw-w-[20rem]">
          <Button
            key="first"
            variant="primary"
            className="tw-w-full"
            onClick={onChatCreate}
          >
            <div className="tw-flex tw-justify-center tw-items-center tw-gap-2">
              <span>New chat</span> <i className="material-icons ">add</i>
            </div>
          </Button>
          {summaries.map((summary) => renderChatLink(summary))}
        </ul>
      )}
    </nav>
  );
};
